const common: Record<string, string> = {
  // Navbar
  "nav.brand": "oopbuyspread",
  "nav.brand_sub": "Deutschland",
  "nav.dropdown_placeholder": "Kategorie wählen",
  "nav.cta_spreadsheet": "oopbuy spreadsheet",
  "nav.cta_buy": "buy it now",
  "nav.home": "Startseite",
  "nav.shopping_guide": "Einkaufsführer",
  "nav.articles": "Artikel",
  "nav.mobile_categories": "Kategorien",

  // Hero
  "hero.title_line1": "Oopbuy",
  "hero.title_line2": "Spreadsheet",
  "hero.title_line3": "Deutschland",
  "hero.subtitle": "Entdecke die besten Produkte & Verkäufer – kuratiert in einer übersichtlichen Tabelle",
  "hero.cta_primary": "Jetzt entdecken",
  "hero.cta_secondary": "Spreadsheet ansehen",
  "hero.badge": "2026 Edition • Jetzt verfügbar",
  "hero.search_placeholder": "Produkte oder Kategorien suchen...",
  "hero.search_button": "Suchen",
  "hero.stat_products": "Kuratierte Produkte",
  "hero.stat_sellers": "Verifizierte Verkäufer",
  "hero.stat_rating": "Nutzerbewertung",

  // Categories
  "categories.title": "Entdecke alle Kategorien",
  "categories.all": "Alle Kategorien",
  "categories.shoes": "Schuhe",
  "categories.hoodies": "Hoodies & Sweater",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jacken",
  "categories.pants": "Hosen & Shorts",
  "categories.headwear": "Kopfbedeckung",
  "categories.sets": "Sets",
  "categories.underwear": "Unterwäsche",
  "categories.jersey": "Trikots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Taschen",
  "categories.belts": "Gürtel",
  "categories.perfumes": "Parfums",
  "categories.other": "Sonstiges",
  "categories.subtitle": "Durchstöbere alle 14 Kategorien und finde genau das, wonach du suchst",
  "categories.explore": "Entdecken",

  // Features
  "features.title_line1": "Warum Oopbuy",
  "features.title_line2": "Spreadsheet?",
  "features.subtitle": "Die intelligente Art, Produkte zu entdecken und zu vergleichen",
  "features.card1_title": "Zeitersparnis",
  "features.card1_desc": "Stundenlanges Suchen war gestern. Mit dem Oopbuy Spreadsheet findest du in Sekunden, was du brauchst.",
  "features.card2_title": "Geprüfte Qualität",
  "features.card2_desc": "Jeder Eintrag wird auf Qualität und Zuverlässigkeit geprüft, bevor er in die Tabelle aufgenommen wird.",
  "features.card3_title": "Immer aktuell",
  "features.card3_desc": "Die Tabelle wird regelmäßig aktualisiert – neue Produkte, neue Verkäufer, neue Angebote.",

  // SEO Article Section
  "seo.label": "/ Oopbuy Spreadsheet Guide",
  "seo.title": "Der ultimative Oopbuy Spreadsheet Guide für Deutschland 2026",
  "seo.paragraph1": "Das Oopbuy Spreadsheet hat sich als unverzichtbares Werkzeug für deutsche Käufer etabliert, die auf der Suche nach den besten Produkten und vertrauenswürdigen Verkäufern sind. In einer Welt, in der Online-Shopping zunehmend komplexer wird, bietet diese innovative Tabellenlösung eine strukturierte und effiziente Möglichkeit, Produkte zu vergleichen, Preise zu analysieren und fundierte Kaufentscheidungen zu treffen.",
  "seo.paragraph2": "Was das Oopbuy Spreadsheet von herkömmlichen Suchmethoden unterscheidet, ist seine durchdachte Organisation. Statt sich durch unzählige Webseiten zu klicken, findest du alle relevanten Informationen an einem zentralen Ort. Von Sneakern über Hoodies bis hin zu Accessoires – jede Kategorie ist übersichtlich dargestellt und mit direkten Links zu vertrauenswürdigen Verkäufern versehen.",
  "seo.paragraph3": "Besonders für den deutschen Markt bietet das Oopbuy Spreadsheet entscheidende Vorteile. Die enthaltenen Versandinformationen berücksichtigen EU-spezifische Anforderungen, Zollbestimmungen und Lieferzeiten nach Deutschland. So vermeidest du unangenehme Überraschungen beim Import und kannst sicher sein, dass deine Bestellungen reibungslos ankommen.",
  "seo.paragraph4": "Die Community hinter dem Oopbuy Spreadsheet wächst stetig. Tausende deutsche Nutzer vertrauen bereits auf die kuratierten Empfehlungen und tragen aktiv zur Verbesserung der Daten bei. Diese kollektive Intelligenz macht das Spreadsheet zu einer lebendigen Ressource, die mit den Trends und Entwicklungen des Marktes Schritt hält.",
  "seo.paragraph5": "Ein weiterer Pluspunkt ist die Transparenz. Jeder Eintrag im Oopbuy Spreadsheet enthält detaillierte Qualitätsbewertungen, echte Nutzererfahrungen und aktuelle Preisinformationen. Diese Offenheit schafft Vertrauen – ein unschätzbarer Wert im Online-Handel, wo versteckte Kosten und fragwürdige Anbieter leider keine Seltenheit sind.",
  "seo.cta": "Zum vollständigen Artikel",
  "seo.badge": "Geprüfte Qualität",
  "seo.author_name": "Oopbuy Redaktionsteam",
  "seo.author_desc": "Experten für Produktvergleiche & Spreadsheet-Analysen",

  // Testimonial
  "testimonial.label": "Was unsere Nutzer sagen",
  "testimonial.title_line1": "Vertraut von tausenden",
  "testimonial.title_line2": "deutschen Käufern",
  "testimonial.quote": "Das Oopbuy Spreadsheet hat meine Art einzukaufen komplett verändert. Ich spare nicht nur Geld, sondern auch unglaublich viel Zeit. Die Qualität der empfohlenen Produkte ist durchweg überzeugend.",
  "testimonial.author": "Markus Weber",
  "testimonial.role": "Berlin, Deutschland",

  // CTA Section
  "cta.title": "Bereit, das beste Oopbuy Spreadsheet zu entdecken?",
  "cta.description_line1": "Über 10.000 kuratierte Produkte warten auf dich.",
  "cta.description_line2": "Starte jetzt und finde genau das, was du suchst.",
  "cta.button": "Jetzt loslegen",

  // Footer
  "footer.tagline_line1": "Dein vertrauenswürdiger",
  "footer.tagline_line2": "Spreadsheet Guide für Deutschland",
  "footer.newsletter": "Newsletter abonnieren",
  "footer.newsletter_placeholder": "Deine E-Mail-Adresse",
  "footer.col1_title": "Navigation",
  "footer.col2_title": "Rechtliches",
  "footer.col3_title": "Ressourcen",
  "footer.col4_title": "Kontakt",
  "footer.home": "Startseite",
  "footer.categories": "Kategorien",
  "footer.guide": "Guide",
  "footer.faq": "FAQ",
  "footer.privacy": "Datenschutz",
  "footer.terms": "AGB",
  "footer.impressum": "Impressum",
  "footer.sitemap": "Sitemap",
  "footer.contact": "Kontakt",
  "footer.copyright": "© 2026 oopbuyspread.click. Alle Rechte vorbehalten.",
  "footer.res_spreadsheet_finder": "Spreadsheet Finder",
  "footer.res_qc_guide": "QC Guide",
  "footer.res_shipping": "Shipping Info",
  "footer.support_email": "support@oopbuyspread.click",

  // Article Page
  "article.back": "Zurück zur Startseite",
  "article.breadcrumb_home": "Startseite",
  "article.breadcrumb_article": "Oopbuy Spreadsheet Guide",
  "article.category": "Guide",
  "article.reading_time": "Lesezeit: 12 Minuten",
  "article.published": "Veröffentlicht: 15. Juli 2026",
  "article.updated": "Aktualisiert: 16. Juli 2026",
  "article.author_name": "Oopbuy Redaktionsteam",
  "article.author_role": "Spreadsheet-Experten",

  // Article Cards Section
  "articleCards.title": "Aktuelle Oopbuy Spreadsheet Artikel",
  "articleCards.subtitle": "Expertenwissen, Guides und Vergleiche für deinen Einkaufserfolg",
  "articleCards.read_more": "Weiterlesen",
  "articleCards.all_articles": "Alle Artikel anzeigen",

  // Article Detail Page
  "articleDetail.back_home": "Zurück zur Startseite",
  "articleDetail.breadcrumb_home": "Startseite",
  "articleDetail.breadcrumb_articles": "Artikel",
  "articleDetail.updated": "Aktualisiert: 16. Juli 2026",
  "articleDetail.cta_title": "Bereit, das Oopbuy Spreadsheet selbst zu entdecken?",
  "articleDetail.cta_text": "Besuche jetzt kaspreadsheet.com und greife auf über 10.000 kuratierte Produkte in 14 Kategorien zu.",
  "articleDetail.cta_button": "Jetzt entdecken",
  "articleDetail.toc": "Inhaltsverzeichnis",
  "articleDetail.related_title": "Weitere Artikel",
  "articleDetail.faq_title": "Häufig gestellte Fragen (FAQ)",
  "articleDetail.cta_main_title": "Bereit, das Oopbuy Spreadsheet selbst zu entdecken?",
  "articleDetail.cta_main_text": "Besuche jetzt kaspreadsheet.com und greife auf über 10.000 kuratierte Produkte in 14 Kategorien zu.",
  "articleDetail.cta_main_button": "Jetzt entdecken",
  "articleDetail.back_label": "Zurück zur",
};

export default common;